import React from 'react'
import { Button, alpha } from '@mui/material'
import { matchPath, useHistory, useLocation } from 'react-router-dom'
import { useIsAdmin } from 'src/session/useSession'
import { useShouldShowAdvancedModeSwitch } from '../api/AdvancedCaseloadProvider'
import { advancedColors, onDark } from '../theme'
import { useAdvancedEnabled } from '../useAdvancedEnabled'
import { useAdvancedMode } from './advancedMode'

const AdvancedModeSwitch = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const shouldShow = useShouldShowAdvancedModeSwitch()
  const isAdmin = useIsAdmin()
  const [advancedMode, setAdvancedMode] = useAdvancedMode()
  const enabled = useAdvancedEnabled()

  if (!enabled) {
    return null
  }

  // Always offer Standard while in Advanced mode so an empty or still-loading caseload cannot trap the coach.
  // Admins get it with an empty caseload too: the Admin panel, where care teams are set up, is in Advanced.
  if (!advancedMode && !shouldShow && !isAdmin) {
    return null
  }

  const advancedMatch = matchPath<{ uid?: string }>(pathname, { path: '/advanced/:uid?' })
  const participantMatch = matchPath<{ uid?: string }>(pathname, { path: '/participant/:uid?' })

  return (
    <Button
      onClick={() => {
        if (advancedMode) {
          setAdvancedMode(false)
          if (advancedMatch) {
            const { uid } = advancedMatch.params
            history.push(uid ? `/participant/${uid}` : '/participant')
          } else if (matchPath(pathname, { path: '/advanced-config', exact: true })) {
            history.push('/participant')
          }
          return
        }
        setAdvancedMode(true)
        if (participantMatch) {
          const { uid } = participantMatch.params
          history.push(uid ? `/advanced/${uid}` : '/advanced')
        }
      }}
      sx={{
        color: advancedMode ? onDark.primary : advancedColors.deep,
        textTransform: 'uppercase',
        px: 1,
        borderRadius: 1,
        '&:hover': {
          backgroundColor: alpha(advancedMode ? onDark.primary : advancedColors.deep, 0.08),
        },
      }}
    >
      {advancedMode ? 'Therapy/Coaching' : 'Advanced'}
    </Button>
  )
}

export default AdvancedModeSwitch
